import HttpStatusCode, { isSuccessStatusCode } from "helpers/HttpStatusCode";
import { ResultPacket } from "models/ResultPacket/ResultPacket";
import ResultResource from "models/ResultResource";
import { ResultFromResource } from "Utilities/ResourceConverter";

const host = '';

export const ResultService = {
	get: async function (code: string) {
		const url = `${host}/api/result/${code}`

		const init = {
			method: 'GET'
		}
		try {
			const response = await fetch(url, init);
			const statusCode = response.status as HttpStatusCode;
			if (!isSuccessStatusCode(statusCode)) {
				console.log("Request failed!");
				return Promise.reject(statusCode);
			}
			else {
				const results = await response.json().then(json => json as ResultResource);
				// return results;
				return ResultFromResource(results);
			}
		}
		catch (reason) {
			return Promise.reject(reason);
		}
	},
	post: async function (result: ResultPacket, token: string) {
		const url = `${host}/api/result`;
		const init = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': token
			},
			body: JSON.stringify(result)
		};

		try {
			const response = await fetch(url, init);
			const statusCode = response.status as HttpStatusCode;
			if (!isSuccessStatusCode(statusCode)) {
				console.log("Request failed!");
				return Promise.reject("Failed!");
			}
			const results = await response.json().then(json => json as ResultResource);
			// return results;
			return ResultFromResource(results);
		}
		catch (reason) {
			return Promise.reject(reason);
		}
	}
}

export default ResultService;